import { DictionaryUser, DictionaryUserSchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { ItemMapping } from "core/src/slices/etlData/slice/etlData.types";
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";

export type PatchUserMappingRequest = {
	usersMapping: ItemMapping;
}

export type PatchUserMappingResponse = {
	dictionaryUsers: DictionaryUser[];
};

export const patchUserMapping = createAppAsyncThunk<PatchUserMappingResponse, PatchUserMappingRequest>(
	"patchUserMapping",
	async ({ usersMapping }, { extra, getState, rejectWithValue, dispatch }) => {

		const { extractUsers, dictionaryUsers } = getState().etlData;

		const tmpDictionaryUsers = [...dictionaryUsers];

		const extractUser = extractUsers.find((extractUser) => extractUser.id === usersMapping.extractId);
		const dictionaryUser = dictionaryUsers.find((dictionaryUser) => dictionaryUser.id === usersMapping.dicoId);

		if (dictionaryUser?.aw_user_id === extractUser?.aw_user_id) {
			return rejectWithValue("No changes");
		}

		if (extractUser && dictionaryUser) {
			try {

				const dictionaryUsersUpdated = await extra.etlClient.update(
					DictionaryUserSchema,
					dictionaryUser.id,
					{
						aw_user_id: extractUser?.aw_user_id
					},
				);

				if (dictionaryUsersUpdated.data) {
					tmpDictionaryUsers.splice(
						tmpDictionaryUsers.findIndex((user) => user.id === usersMapping.dicoId),
						1,
						dictionaryUsersUpdated.data
					);
				}
			} catch (error) {
				dispatch(displayApiErrorToast(error));
			}

		}

		return {
			dictionaryUsers: tmpDictionaryUsers
		}
	}
);
